import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
registerLocale('sv', sv);

const DualDatePickers = ({ onChange, startDate, endDate, customInput }) => {
    const [firstDate, setFirstDate] = useState(startDate);
    const [lastDate, setLastDate] = useState(endDate);

    const updateStartDate = (date) => {
        setFirstDate(date);
        if (lastDate < date) setLastDate(date);
    };

    useEffect(() => {
        const start = moment(firstDate).format('YYYY-MM-DD');
        const end = moment(lastDate).format('YYYY-MM-DD');

        onChange({ startDate: start, endDate: end });
    }, [firstDate, lastDate]);

    return (
        <div className='d-flex justify-content-between align-items-right'>
            <span>
                <DatePicker
                    selected={firstDate}
                    onChange={(newDate) => updateStartDate(newDate)}
                    dateFormat='yyyy-MM-dd'
                    customInput={customInput}
                    showDayMonthPicker
                    popperPlacement='top-start'
                    minDate={null}
                    maxDate={lastDate}
                    locale='sv'
                />
            </span>
            <span className='oi oi-arrow-right px-md-3 px-1'></span>
            <span>
                <DatePicker
                    selected={lastDate}
                    onChange={newDate => setLastDate(newDate)}
                    dateFormat='yyyy-MM-dd'
                    customInput={customInput}
                    showDayMonthPicker
                    popperPlacement='top-start'
                    minDate={firstDate}
                    maxDate={null}
                    locale='sv'
                />
            </span>
        </div>
    );
}

export default DualDatePickers;